// extracted by mini-css-extract-plugin
export default {"container":"appBody__container___SwonW"};